import { render, staticRenderFns } from "./expert-myproblem.vue?vue&type=template&id=4bdb9063&scoped=true"
import script from "./expert-myproblem.vue?vue&type=script&lang=js"
export * from "./expert-myproblem.vue?vue&type=script&lang=js"
import style0 from "./expert-myproblem.vue?vue&type=style&index=0&id=4bdb9063&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb9063",
  null
  
)

export default component.exports